import audioWorklet from "./audioWorklet.js?url";

/**
 * 使用AudioWorklet处理音频数据
 * 输出 16k 采样率、16bit、单通道的 PCM 数据
 */
class AudioProcessor {
  private audioContext: AudioContext | null;
  private mediaStreamSource: MediaStreamAudioSourceNode | null;
  private workletNode: AudioWorkletNode | null;
  private filter: BiquadFilterNode | null;

  constructor() {
    this.audioContext = null;
    this.mediaStreamSource = null;
    this.workletNode = null;
    this.filter = null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  public onMessage: (data: any) => void = (_data: any) => {
    throw new Error("on message not im");
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  public onError: (error: any) => void = (error: any) => {
    throw new Error(error);
  };

  async start(stream: MediaStream) {
    this.audioContext = new AudioContext();
    this.mediaStreamSource = this.audioContext.createMediaStreamSource(stream);
    // 过滤掉 8k 以上的音频，高音音频在重采样之后会为16k之后，会被映射到 8k 以下，导致噪音和电流声之类的
    this.filter = this.audioContext.createBiquadFilter();
    this.filter.type = "lowpass";
    this.filter.frequency.value = 8000;
    this.audioContext.audioWorklet
      .addModule(audioWorklet)
      .then(() => {
        this.workletNode = new AudioWorkletNode(
          this.audioContext!,
          "pcm-worklet-processor",
          {
            numberOfInputs: 1,
            numberOfOutputs: 1,
            outputChannelCount: [1],
            processorOptions: {
              inputSampleRate: this.audioContext!.sampleRate,
            },
          }
        );
        this.mediaStreamSource!.connect(this.filter!)
          .connect(this.workletNode!)
          .connect(this.audioContext!.destination);
        this.workletNode.port.onmessage = (e) => {
          this.onMessage(e.data);
        };
      })
      .catch((error) => {
        this.onError(error);
      });
  }

  dispose() {
    this.workletNode?.disconnect();
    this.filter?.disconnect();
    this.mediaStreamSource?.disconnect();
    this.audioContext?.close();
    this.audioContext = null;
    this.mediaStreamSource = null;
    this.workletNode = null;
    this.filter = null;
  }
}

export default AudioProcessor;
